    import { convertUrl } from "../helpers/helper"
    import { Response } from "../types/backend.type"
    import http from "../utils/http"

    const triggerSpeedTest = async (token: string, body: any, randomstring: string): Promise<Response<any>> => {
      const response = await http.postTass(
        convertUrl('iwsTriggerSpeedTest'),
        JSON.stringify(body),
        token,
        randomstring
      )
      return response
    }
    const triggerSpeedTestGetResult = async (token: string, body: any, randomstring: string): Promise<Response<any>> => {
      const response = await http.postTass(
        convertUrl('iwsTriggerSpeedTestStatus'),
        JSON.stringify(body),
        token,
        randomstring
      )
      return response
    }
    const triggerDeviceReboot = async (token: string, body: any, randomstring: string): Promise<Response<any>> => {
      await new Promise(resolve => setTimeout(resolve, 4000));
      const response = await http.postIWS(
        convertUrl('iwsTriggerDeviceReboot'),
        JSON.stringify(body),
        token,
        randomstring
      )
      return response
    }

    const triggerWiFiDriverRestart = async (token: string, body: any, randomstring: string): Promise<Response<any>> => {
      await new Promise(resolve => setTimeout(resolve, 4000));
      const response = await http.postIWS(
        convertUrl('iwsTriggerWiFiDriverRestart'),
        JSON.stringify(body),
        token,
        randomstring
      )
      return response
    }
    const iwsGetHouseholdHealth = async (
      token: string,
      body: any,
      randomstring: string
    ): Promise<Response<any>> => {
      const response = await http.postTass(
        convertUrl('iwsGetHouseholdHealth'),
        JSON.stringify(body),
        token,
        randomstring
      )
      return response
    } 
    const triggerChannelChange = async (
      token: string,
      body: any,
      randomstring: string
    ): Promise<any> => {
      await new Promise(resolve => setTimeout(resolve, 4000));
      const response = await http.postIWS(
        convertUrl('iwsTriggerChannelChange'),
        JSON.stringify(body),
        token,
        randomstring
      );
    
      // Handle 204 No Content
      if (response.status === 204) {
        return { status: 204, message: 'No content' };
      }
    
      // Try to parse JSON for other responses
      try {
        const data = await response.json();
        return data;
      } catch (err) {
        console.error('Failed to parse JSON response', err);
        return { status: response.status };
      }
    };

    export { triggerSpeedTest, triggerDeviceReboot, triggerWiFiDriverRestart, iwsGetHouseholdHealth, triggerChannelChange, triggerSpeedTestGetResult }
